import { Link } from "react-router-dom";
import { Sparkles, Shield, Mail } from "lucide-react";
import SiteFooter from "./SiteFooter";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative z-10 min-h-screen">
      <section className="relative px-6 pt-24 pb-16 sm:pt-32">
        <div className="mx-auto max-w-4xl text-center">
          <span className="badge-system animate-pulse-glow">
            <Sparkles className="h-3 w-3" />
            System Online
          </span>
          <h1 className="font-fantasy mt-6 text-5xl leading-tight text-white sm:text-7xl">
            <span className="neon-text">ARISE</span>{" "}
            <span className="text-white/80">FORGE</span>
          </h1>
          <p className="mx-auto mt-6 max-w-xl font-system text-lg text-[var(--ink-dim)]">
            Hunt habits. Forge progress. Level up your real life.
          </p>

          <div className="divider-glow mx-auto mt-10 w-2/3 max-w-md" />

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/privacy" data-testid="home-privacy-cta" className="btn-system">
              <Shield className="h-3.5 w-3.5" />
              Privacy & Support
            </Link>

            <a
              href="mailto:ariseforgeapp@gmail.com"
              data-testid="home-email-cta"
              className="btn-system"
            >
              <Mail className="h-3.5 w-3.5" />
              Contact Support
            </a>
          </div>

          <p className="mt-4 text-sm text-[var(--ink-dim)]">
            Support: ariseforgeapp@gmail.com
          </p>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
